'use strict';

var IMask = require('imask');
var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var IMask__default = /*#__PURE__*/_interopDefaultCompat(IMask);

const useIMaskInstance = ({ inputRef, options, }) => {
    const maskRef = React.useRef(null);
    React.useEffect(() => {
        const mask = IMask__default.default(inputRef.current, options);
        maskRef.current = mask;
        return () => {
            mask.destroy();
        };
    }, [inputRef, options]);
    return maskRef;
};
const useIMaskAcceptListener = (maskRef, listener) => {
    React.useEffect(() => {
        const mask = maskRef.current;
        if (!mask) {
            return;
        }
        mask.on('accept', listener);
        return () => {
            mask.off('accept', listener);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listener]);
};

exports.useIMaskAcceptListener = useIMaskAcceptListener;
exports.useIMaskInstance = useIMaskInstance;
//# sourceMappingURL=useIMask.js.map
